import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { useParams, useNavigate } from 'react-router-dom'
import '../../css/generals/paper.css'
import styles from '../../css/modals/Modal.module.css'
import Swal from 'sweetalert2'
import { postData } from '../../actions/servicesHttp'
import { popupSimple } from '../../components/generals/popups'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function ModalBackgroundChange ({ btnError, btnSuccess, title, show, onHide, type, identity, devices, socketSendActions, realTime }) {
  const { id } = useParams()
  const [files, setFiles] = useState(null)
  const { t } = useTranslation('dashboardDevice')
  const navigate = useNavigate()

  function closeModal () {
    onHide()
    setFiles(null)
  }

  function inputFileHandling () {
    const input = document.querySelector('#inputFileBC')

    input.addEventListener('change', e => {
      const span = document.querySelector('#fancy_file_name_document')

      if (input?.files?.length === 0) {
        span.innerHTML = t('modalBackgroundChange.label2')
      } else if (input?.files?.length > 0) {
        span.innerHTML = input.files[0].name
        setFiles(input.files)
      }
    })
  }

  const uploadImgs = async () => {
    const f = new FormData()

    if (files !== null) {
      for (let i = 0; i < files.length; i++) {
        f.append('files', files[i])
      }

      let timerInterval

      Swal.fire({
        title: t('modalBackgroundChange.message1'),
        html: '',
        timer: 30000,
        timerProgressBar: false,
        didOpen: () => {
          Swal.showLoading()
          timerInterval = setInterval(500)
        },
        willClose: () => {
          clearInterval(timerInterval)
        }
      })

      const response = await postData('upload/wallpaper', f, navigate)

      if (response.data.length !== false) {
        let url = response.data.url
        url = url.trim()
        const splitUrl = url.split('/')
        installBackground(url, splitUrl)
        setFiles(null)
        closeModal()
      } else {
        popupSimple('error', t('modalBackgroundChange.message2'))
      }
    } else {
      popupSimple('info', t('modalBackgroundChange.message3'))
    }
  }

  const installBackground = async (url, fileName) => {
    const idsDevices = []
    devices?.forEach(devices => { idsDevices.push(devices.id) })

    const json = {
      action: 'install',
      data: {
        fileName: fileName[fileName.length - 2] + '.' + fileName[fileName.length - 1],
        url,
        type: 'wallpaper'
      },
      date: new Date(Date.now()),
      devicesId: type === 'devices' ? [parseInt(id)] : [],
      groupsId: type === 'groups' ? [parseInt(id)] : []
    }

    if (realTime) {
      socketSendActions([json])
      popupSimple('success', t('modalBackgroundChange.message4'))
    } else {
      const { data } = await postData('actions', [json], navigate)
      if (type === 'devices') {
        if ((data[0].result === true) && (Array.isArray(data[0].sendings)) && (data[0].sendings.length === 0)) {
          popupSimple('success', t('modalBackgroundChange.message5'))
        } else if ((data[0].result === true) && (Array.isArray(data[0].sendings)) && (data[0].sendings.length > 0) && (data[0].sendings.includes(identity))) {
          popupSimple('success', t('modalBackgroundChange.message4'))
        } else {
          popupSimple('error', t('modalBackgroundChange.message6'))
        };
      } else {
        if ((data[0].result === true)) {
          popupSimple('success', t('modalBackgroundChange.message5'))
        } else {
          popupSimple('error', t('modalBackgroundChange.message6'))
        }
      }
    }
  }

  return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                key={'backgroundChange'}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title" className={styles.modalTitle}>
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.modalBackgroundChangeBody}>
                        <label>{t('modalBackgroundChange.label1')}</label>
                        <input type="file" accept="image/*" id="inputFileBC" name="files" className={styles.fancy_file}/>
                        <label htmlFor="inputFileBC" className={styles.fancy_file_label}>
                            <span className={styles.fancy_file_button} onClick={() => inputFileHandling()}>
                                <i className="pi pi-download"></i></span>
                            <span className={styles.fancy_file_name}>
                                <span id="fancy_file_name_document">{t('modalBackgroundChange.label2')}</span>
                            </span>
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} variant="danger">
                        {btnError}
                    </Button>
                    <Button onClick={() => uploadImgs()} variant="primary" id="btnModalSucess" >
                        {btnSuccess}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
  )
}

ModalBackgroundChange.propTypes = {
  btnError: PropTypes.string,
  btnSuccess: PropTypes.string,
  title: PropTypes.string,
  show: PropTypes.bool,
  onHide: PropTypes.func,
  type: PropTypes.string,
  identity: PropTypes.string,
  devices: PropTypes.array,
  socketSendActions: PropTypes.func,
  realTime: PropTypes.bool
}
